module.exports = __webpack_public_path__ + "img/compact.39f9a9bd.png";